export const FORGOT_PASS_REQUEST = 'FORGOT_PASS_REQUEST'
export const FORGOT_PASS_SUCCESS = 'FORGOT_PASS_SUCCESS'
export const FORGOT_PASS_FAILED = 'FORGOT_PASS_FAILED'
